import { type UseCaseItem } from '../../_shared/_components/UseCaseSelector/UseCaseSelector';
import { type Suggestion } from '../../_shared/_components/forms/TextAreaInputField/TextAreaInputField';
import { AI_TOOLKIT_OPERATIONS } from '../../_shared/_context/types';

export const VIDEO_EDIT_SUCCESS_COPY = {
    [AI_TOOLKIT_OPERATIONS.GENERATE]: {
        title: "It's ready! Preview and download your edited video below.",
        subtitle: 'A copy of your video has also been sent to your email.',
    },
    [AI_TOOLKIT_OPERATIONS.UPSCALE]: {
        title: 'Your 4K edit is ready!',
        subtitle: 'Preview and download your upscaled video below. A copy has been sent to your email.',
    },
} as const;

export const VIDEO_EDIT_USE_CASES: UseCaseItem[] = [
    { id: 'change-object', title: 'Change object', imgUrl: '/assets/images/video-editor/change-object.webp' },
    {
        id: 'change-background',
        title: 'Change background',
        imgUrl: '/assets/images/video-editor/change-background.webp',
    },
    { id: 'change-colors', title: 'Change colors', imgUrl: '/assets/images/video-editor/change-colors.webp' },
    {
        id: 'change-video-style',
        title: 'Change video style',
        imgUrl: '/assets/images/video-editor/change-video-style.webp',
    },
    {
        id: 'remove-background',
        title: 'Remove background',
        imgUrl: '/assets/images/video-editor/remove-background.webp',
    },
    { id: 'custom-edit', title: 'Custom edit', imgUrl: '/assets/images/video-editor/custom-edit.webp' },
];

export const VIDEO_EDIT_USE_CASE_SUGGESTIONS: Record<string, Suggestion[]> = {
    'change-object': [
        { label: 'Change color', promptText: 'Change color' },
        { label: 'Replace object', promptText: 'Replace object' },
        { label: 'Change subject', promptText: 'Change subject' },
        { label: 'Remove object', promptText: 'Remove object' },
    ],
    'change-background': [
        { label: 'Change weather', promptText: 'Change weather' },
        { label: 'Change lighting', promptText: 'Change lighting' },
        { label: 'Change backdrop', promptText: 'Change backdrop' },
    ],
    'change-colors': [{ label: 'Make color palette cooler/warmer', promptText: 'Make color palette cooler/warmer' }],
    'change-video-style': [{ label: 'Make video animated', promptText: 'Make video animated' }],
    'remove-background': [{ label: 'Remove background', promptText: 'Remove background' }],
    'custom-edit': [
        { label: 'Add elements', promptText: 'Add elements' },
        { label: 'Change motion', promptText: 'Change motion' },
        { label: 'Add effects', promptText: 'Add effects' },
        { label: 'Change framing', promptText: 'Change framing' },
        { label: 'Change mood', promptText: 'Change mood' },
    ],
};

export const VIDEO_EDIT_USE_CASE_PLACEHOLDERS: Record<string, string> = {
    'change-object': 'Modify, replace or delete an object in the video...',
    'change-background': 'Change the styling or details of the video background...',
    'change-colors': 'Modify the color palette of the video...',
    'change-video-style': 'Modify the styling and aesthetics of a video...',
    'remove-background': 'Remove the background to isolate the subject of the video...',
    'custom-edit': 'Customize the video in your own way...',
};
